import { getUsersBySearchAction } from '@xmatters/redux/actions/listPage';
import { hydrateActiveUsers as hydrator } from '../groupList';

export const GET_SYSTEM_AUDIT_REPORT_DATA =
  'systemAuditReport/GET_SYSTEM_AUDIT_REPORT_DATA';
export const GET_SYSTEM_AUDIT_REPORT_DATA_START = `${GET_SYSTEM_AUDIT_REPORT_DATA}_START`;
export const GET_SYSTEM_AUDIT_REPORT_DATA_SUCCESS = `${GET_SYSTEM_AUDIT_REPORT_DATA}_SUCCESS`;
export const GET_SYSTEM_AUDIT_REPORT_DATA_FAIL = `${GET_SYSTEM_AUDIT_REPORT_DATA}_FAIL`;
export const GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS = 'SYSTEM_AUDIT_SEARCH_USERS';
export const GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_START = `${GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS}_START`;
export const GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_SUCCESS = `${GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS}_SUCCESS`;
export const GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_FAIL = `${GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS}_FAIL`;
export const SYSTEM_AUDIT_REPORT_ACTIVE_USERS_FILTERS =
  'SYSTEM_AUDIT_REPORT_ACTIVE_USERS_FILTERS';
export const SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS =
  'SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS';
export const SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS =
  'SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS';
export const SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_START = `${SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS}_START`;
export const SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_SUCCESS = `${SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS}_SUCCESS`;
export const SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_FAIL = `${SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS}_FAIL`;
export const SYSTEM_AUDIT_REPORT_RESET_USERS_FILTERS =
  'SYSTEM_AUDIT_REPORT_RESET_USERS_FILTERS';

export const hydrateActiveDynamicFilters = payload => {
  return {
    type: SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
    payload,
  };
};

export const hydrateActiveUsers = activeUserIds => {
  const params = {};

  if (activeUserIds) {
    params.id = activeUserIds;
  }

  return {
    ...hydrator(activeUserIds),
    type: SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS,
  };
};

export const getUsersBySearch = getUsersBySearchAction(
  GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS,
);

export const setActiveUserFilters = users => ({
  type: SYSTEM_AUDIT_REPORT_ACTIVE_USERS_FILTERS,
  payload: users,
});

export const resetUserFilters = users => ({
  type: SYSTEM_AUDIT_REPORT_RESET_USERS_FILTERS,
  payload: users,
});

export const getSystemAuditReportData = params => {
  const {
    from,
    to,
    limit,
    offset,
    changedBy,
    sortBy,
    sortOrder,
    search,
    nameUuids,
    reportTypes,
  } = params;

  return {
    type: GET_SYSTEM_AUDIT_REPORT_DATA,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/abe/1/audit-reports',
      params: {
        from,
        to,
        limit,
        offset,
        ...(changedBy && { changedBy }),
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder }),
        ...(search && { search }),
        ...(nameUuids && { nameUuids }),
        ...(reportTypes && { reportTypes }),
      },
    },
  };
};
